import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

/** Shows a thin install prompt when the PWA is installable. */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("ll-install-dismissed") === "1");

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!deferred || dismissed) return null;

  const install = async () => {
    deferred.prompt();
    const choice = await deferred.userChoice;
    if (choice.outcome) {
      setDeferred(null);
    }
  };

  const close = () => {
    sessionStorage.setItem("ll-install-dismissed", "1");
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-4 left-4 z-[1500] bg-[#0d0d0d] border border-[#ff8c00] px-4 py-3 flex items-center gap-3 max-w-sm" data-testid="install-prompt">
      <DownloadSimple size={20} className="text-[#ff8c00] shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.25em] text-[#ff8c00] font-bold">Install Load Logic</div>
        <div className="text-xs text-[#a1a1aa]">Add to home screen for offline access</div>
      </div>
      <button
        onClick={install}
        className="px-3 py-1.5 bg-[#ff8c00] text-black text-[10px] uppercase tracking-[0.2em] font-bold whitespace-nowrap"
        data-testid="install-btn"
      >
        Install
      </button>
      <button onClick={close} className="w-7 h-7 hover:bg-[#1a1a1a] flex items-center justify-center" data-testid="install-dismiss">
        <X size={14} />
      </button>
    </div>
  );
}
